import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/common/home.vue";
import store from "./modules/store/index.js";
import records from "./modules/records/index.js";
import Login from "../views/common/login.vue";
import upload from "./modules/upload/index.js";
import { isEmpty } from "@/utils/utils.js";
Vue.use(VueRouter);

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
const routes = [
  {
    path: "/",
    name: "home",
    component: Home,
    children: [store]
  }
];

const router = new VueRouter({
  routes
});
// router.beforeEach(async (to, from, next) => {
//   if (to.matched.length === 0) {
//     from.name ? next({ name: from.name }) : next({ name: "login" });
//   } else {
//     if (isEmpty(localStorage.getItem("integration-username"))) {
//       if (to.name == "goods" || to.name == "records" || to.name == "upload") {
//         next({ name: "login" });
//       }
//       if (to.name == "login") {
//         next();
//       }
//     } else {
//       next();
//     }
//   }
// });
export default router;
export { routes };
